import React from 'react';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import styles from 'stylesheets/components/display_pricing';

export function DisplayPricing({ audiobook }) {
  function renderListingAndDiscountPricing() {
    if (!audiobook.currentProduct) {
      return null;
    }

    const discountPrice = (
      <div
        className={styles.discountPrice}
        aria-label={`Discount price: ${audiobook.currentProduct.discountPrice}`}
      >
        {audiobook.currentProduct.discountPrice}
      </div>
    );

    if (audiobook.currentProduct.isFreeListing) {
      return (
        <React.Fragment>
          <div className={styles.freeListing}>Our Price:</div>
          {discountPrice}
        </React.Fragment>
      );
    }

    if (!audiobook.currentProduct.showListingPrice) {
      return discountPrice;
    }

    return (
      <React.Fragment>
        <div className={styles.listingPrice} aria-hidden='true'>
          {audiobook.currentProduct.listingPrice}
        </div>
        {discountPrice}
      </React.Fragment>
    );
  }
  
  if (audiobook.futureSaleDate) {
    return (
      <div className={styles.displayPricing}>
        <div className={styles.futureSaleDate}>
          <span className={styles.releaseDateLabel}>Release:</span>
          <span>{audiobook.futureSaleDate}</span>
        </div>
      </div>
    );
  }

  return <div className={styles.displayPricing} data-testid='display-pricing'>{renderListingAndDiscountPricing()}</div>;
};

DisplayPricing.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
};